import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  HostListener,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  AuthSevices,
  ClaimService,
  OpportunityStageService,
  TaskService,
  TimeconversionService,
  ToastMessageService,
} from '@fitness-force/api';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import { ClientInfoSidebarComponent } from '@fitness-force/core';
import { OpportunityBoardType, StaffStatus } from '@fitness-force/enum';
import {
  DataGridComponent,
  NoComponentComponent,
} from '@fitness-force/grid';
import {
  Claim,
  DeleteTaskRequest,
  ReAssignTaskRequest,
  STAFFINTERFACE,
  TaskOutcomeDetails,
  TENANTSINTERFACE,
} from '@fitness-force/models';
import {
  ClientInfoComponent,
  DefaultDateTimeComponent,
  MultiSelectStaffComponent,
  OpportunityTypeComponent,
  SharedModule,
  StaffInfoComponent,
  TaskCreateComponent,
  TaskTypeComponent,
  TrackStatusComponent,
} from '@fitness-force/shared';
import { Store } from '@ngrx/store';
import { dateCollection, weekData } from '@fitness-force/pipes/datetime-format';
import { TranslateService } from '@ngx-translate/core';
import { TaskCategoryDropdownComponent } from '@fitness-force/crm';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DragDropModule } from 'primeng/dragdrop';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { PopoverModule } from 'primeng/popover';
import { RippleModule } from 'primeng/ripple';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DrawerModule } from 'primeng/drawer';
import { StyleClassModule } from 'primeng/styleclass';
import { TooltipModule } from 'primeng/tooltip';
import { Observable, BehaviorSubject, combineLatestWith } from 'rxjs';
import { ROUTER_STATE, STAFF_STATE, TENANTS_INFO } from '../../../state/app.state';
import { DateFormatedComponent } from '@fitness-force/grid-utility';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { AssignedToComponent } from '@fitness-force/common/assigned-to';

import { ErrorMsgComponent } from '@fitness-force/errors';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DataGridComponent,
    StyleClassModule,
    SelectModule,
    DragDropModule,
    DialogModule,
    ChipModule,
    CheckboxModule,
    ButtonModule,
    DatePickerModule,
    RippleModule,
    StyleClassModule,
    SelectButtonModule,
    MultiSelectModule,
    InputTextModule,
    ButtonModule,
    DividerModule,
    TaskCreateComponent,
    TaskCategoryDropdownComponent,
    TooltipModule,
    MultiSelectStaffComponent,
    PopoverModule,
    AssignedToComponent,
    ErrorMsgComponent,
    DrawerModule,
    ClientInfoSidebarComponent,
    SharedModule
]
})
export class TaskListComponent implements OnInit {
  activefilters: any[] = [];
  taskTypes: any = [];
  taskTypesCategory!: any;
  selectedFilter: { name: string } | undefined;
  selectedTaskType: { name: string } | undefined;
  showToolbar: boolean = false;
  currentUrl = '';
  getAccessTenantList$: Observable<any> | any;
  tenantId: number = 0;
  columns = new BehaviorSubject<Array<any>>([]);
  tableData = new BehaviorSubject<Array<any>>([]);
  outcomeDetail = <TaskOutcomeDetails>{};
  tasksOtherParam = new Map();
  tasksParams = new Map();
  tags: any[] = [];
  selectedClient = new Map();
  selectedTags: any[] | undefined;
  showCalendar: boolean = false;
  taskCategory: any[] = [];
  selectedTaskCategory: { name: string } | undefined;
  calendarInput: Date | undefined;
  allBoards: any = [];
  showTaskCreate: boolean = false;
  showTaskMultiple = false;
  emptyStateComponent$ = new BehaviorSubject<any>(NoComponentComponent);
  applyFilterArray = new Map();
  showBulkActionBar = false;
  selectAllTaskListData = new BehaviorSubject(false);
  customFilterForm: UntypedFormGroup = new UntypedFormGroup({});
  step = 'today';

  months: Array<string> = CONSTANTS_DATA.MONTHS;
  tableRecord: any = [];
  totalRecordLength = new BehaviorSubject({
    totalPage: 10,
    totalItems: 10,
    currentPage: 0,
    reset: false,
  });
  // representativeIds = new Map()
  selectedStaffIds: any = [];
  resetGridPagination = true;
  // Loading
  loading = false;
  selectedClientIds: any = [];

  pageNumber: number = 1;
  pageSize: number = 10;
  typeFilter: string[] = [];
  showClientSidebar = false;
  activeClientId = 0;
  showDeleteTaskPopup: boolean = false;
  disableDeleteBtn: boolean = false;
  disableReassigneBtn: boolean = false;
  allSelected: boolean = false;
  reassignTasksPopup: boolean = false;
  _sessionOwner = new BehaviorSubject<number[]>([0]);
  claim$: Observable<Claim[]> = new Observable();
  changeSessionOwnerForm: UntypedFormGroup = {} as UntypedFormGroup;
  currentUserDetails: any = {};

  constructor(
    private fb: UntypedFormBuilder,
    public translate: TranslateService,
    private router: Router,
    private store: Store,
    private taskService: TaskService,
    private opportunityStageService: OpportunityStageService,
    private authService: AuthSevices,
    private timeService: TimeconversionService,
    private toastMessageService: ToastMessageService,
    private claimService: ClaimService
  ) {
    this.taskTypesCategory = [
      { name: 'DUE_TODAY', key: 'today' },
      { name: 'OVER_DUE', key: 'overdue' },
      { name: 'ALL_DUE_TASKS', key: 'scheduled' },
      { name: 'TOMORROW', key: 'tomorrow' },
      { name: 'THIS_WEEK', key: 'in 1 week' },
      { name: 'NEXT_WEEK', key: 'In 2 Weeks' },
      { name: 'COMPLETED', key: 'completed' },
    ];
  }

  ngOnInit(): void {
    this.changeSessionOwnerForm = this.fb.group({});
    this.changeSessionOwnerForm.addControl('session_owner',new UntypedFormControl('',[Validators.required]));
    this.claim$ = this.claimService.GetClaim(environment.BASE_URL);
    this.componentInit();
  }

  componentInit() {
    this.currentUserDetails = this.authService.decodedToken;
    this.selectedStaffIds = JSON.parse(
      localStorage.getItem('TASK_STAFF_LIST') || '[]'
    );
    if (
      this.selectedStaffIds.length == 0 
    ) {
      this.selectedStaffIds.push(
        parseInt(this.authService.currentUserDetails()?.Id)
      );
    }
    this.tasksParams.set('status', {
      paramName: 'status',
      paramValue: 'Scheduled',
    });
    this.tasksParams.set('PageNumber', {
      paramName: 'PageNumber',
      paramValue: this.pageNumber,
    });
    this.tasksParams.set('PageSize', {
      paramName: 'PageSize',
      paramValue: this.pageSize,
    });
    let startDate = new Date(new Date().setHours(0, 0, 0));
    let endDate = new Date(new Date().setHours(23, 59, 59));
    this.tasksParams.set('due_date_from', {
      paramName: 'due_date_from',
      paramValue: this.timeService.ConvertLocalDateTimeToUTC(startDate),
    });
    this.tasksParams.set('due_date_to', {
      paramName: 'due_date_to',
      paramValue: this.timeService.ConvertLocalDateTimeToUTC(endDate),
    });
    this.tableData.next([]);
    this.customFilterForm = this.fb.group({
      dueDateFrom: [''],
      dueDateTo: [''],
      taskCategory: [''],
    });
    this.router.events.subscribe((data: any) => {
      this.currentUrl = data.url;
    });
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.store.select(ROUTER_STATE).subscribe((rd) => {
      this.currentUrl = rd.url;
    });
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.opportunityStageService
          .OpportunityStageMasterListService(
            this.tenantId,
            OpportunityBoardType.NewMemberBoard
          )
          .subscribe((res) => {
            this.allBoards = res.items;
          });
        this.store.dispatch({ type: 'ROUTER_GO' });
        
        this.getAllTask();
        this.taskTypes = [];
      }
    });
    this.ValidSessionOwners();
  }

  fetchNextSetData(e: any) {
    this.pageNumber = e.pn;
    this.pageSize = e.ps;
    this.tasksParams.set('PageNumber', {
      paramName: 'PageNumber',
      paramValue: e.pn,
    });
    this.tasksParams.set('PageSize', {
      paramName: 'PageSize',
      paramValue: e.ps,
    });
    this.showBulkActionBar = false;
    this.gettableRecord([]);
    this.selectedClient.clear();
    this.getAllTask();
  }

  @HostListener('window:visibilitychange', ['$event'])
  VisibilityChange(event: any): void {
    if (event.target.visibilityState.toLowerCase() == 'visible')
      this.getAllTask(false);
  }

  HideTaskCreate(e: any) {
    this.showTaskCreate = e;
    this.showTaskCreate = false;
  }

  HideTaskCreateMulti(e: any) {
    this.showTaskCreate = false;
    this.showTaskMultiple = e;
  }

  get getAllParams(): Array<any> {
    return [...this.tasksParams.values()];
  }

  getAllTask(showSkeleton: boolean = true) {
    const params =
      this.applyFilterArray.size > 0
        ? [...this.getApplyFilterArray, ...this.getAllParams]
        : this.getAllParams;
    const clientRepresentatives =
      this.selectedStaffIds.length > 0
        ? [...this.getSelectedRepresetativeIds, ...params]
        : params;
    this.loading = showSkeleton;
    this.taskService
      .TaskGetAll(this.tenantId, clientRepresentatives)
      .subscribe((res: any) => {
        this.gettableRecord(res.items.length > 0 ? res.items : []);
        this.tableData.next(res.items.length > 0 ? res.items : []);
        this.totalRecordLength.next({
          totalPage: res.total_pages,
          totalItems: res.total_items,
          currentPage: res.current_page,
          reset: this.resetGridPagination,
        });
        this.emptyStateComponent$.next(NoComponentComponent);
        this.GetTableColumns();
        this.resetGridPagination = false;
        this.selectAllTaskListData.next(true);
        this.loading = false;
      });
  }

  GetTableColumns() {
    this.translate
      .get([
        'TASK_LIST.COLUMNS.STATUS',
        'TASK_LIST.COLUMNS.TITLE',
        'TASK_LIST.COLUMNS.CONTACT_NAME',
        'TASK_LIST.COLUMNS.OPPORTUNITY',
        'TASK_LIST.COLUMNS.TASK_CATEGORY',
        'TASK_LIST.COLUMNS.TASK_TYPE',
        'TASK_LIST.COLUMNS.ASSIGNED_TO',
        'TASK_LIST.COLUMNS.DUE_DATE',
        'TASK_LIST.COLUMNS.TIME',
        'TASK_LIST.COLUMNS.CREATED_DATE'
      ])
      .subscribe((translations) => {
        this.TableColumnsTransalation(translations);
      });
  }

  TableColumnsTransalation(translations: any) {
    this.columns.next([
      {
        title: translations['TASK_LIST.COLUMNS.STATUS'],
        classes: ' py-2  w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'status',
        type: 'component',
        data: { name: TrackStatusComponent, inputs: 'opportunity' },
      },
      {
        title: translations['TASK_LIST.COLUMNS.TITLE'],
        classes: ' py-2  w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'title',
        type: 'default',
      },
      {
        title: translations['TASK_LIST.COLUMNS.CONTACT_NAME'],
        classes: '  py-2  w-15rem white-space-nowrap relative',
        sortable: true,
        filterable: true,
        type: 'component',
        data: { name: ClientInfoComponent },
      },
      {
        title: translations['TASK_LIST.COLUMNS.OPPORTUNITY'],
        classes: '  py-2  w-15rem white-space-nowrap relative',
        sortable: true,
        filterable: true,
        dataProperty: 'oppportunity_info',
        type: 'component',
        data: {
          name: OpportunityTypeComponent,
          additionData: true,
          aData: this.allBoards,
        },
      },
      {
        title: translations['TASK_LIST.COLUMNS.TASK_CATEGORY'],
        classes: ' py-2  w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'name_primary_language',
        type: 'default',
      },
      {
        title: translations['TASK_LIST.COLUMNS.TASK_TYPE'],
        classes: '  py-2  w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'type',
        type: 'component',
        data: { name: TaskTypeComponent },
      },
      {
        title: translations['TASK_LIST.COLUMNS.ASSIGNED_TO'],
        classes: '  py-2  w-15rem white-space-nowrap relative',
        sortable: true,
        filterable: true,
        dataProperty: 'assigned_to_staff_id',
        type: 'component',
        // data: {name: AssignToStaffComponent}
        data: { name: StaffInfoComponent },
      },
      {
        title: translations['TASK_LIST.COLUMNS.DUE_DATE'],
        classes: ' py-2  w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'scheduled_date',
        type: 'component',
        data: {
          name: DefaultDateTimeComponent,
          fetch_key: 'scheduled_date',
          additionData: true,
          aData: { keyname: 'scheduled_date', dateFormat: 'MMM d, y, h:mm a' },
        },
      },
      {
        title: translations['TASK_LIST.COLUMNS.TIME'],
        classes: ' py-2  w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'scheduled_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: { KeyName: 'scheduled_date', format: 'shortTime' },
        },
      },
      {
        title: translations['TASK_LIST.COLUMNS.CREATED_DATE'],
        classes: ' py-2  w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'created_date',
        type: 'component',
        data: {
          name: DefaultDateTimeComponent,
          fetch_key: 'created_date',
          additionData: true,
          aData: { keyname: 'created_date', dateFormat: 'MMM d, y, h:mm a' },
        },
      },
    ]);
  }

  gettableRecord(items: any) {
    return (this.tableRecord = items);
  }
  get DueDateFrom(): UntypedFormControl {
    return this.customFilterForm.get('dueDateFrom') as UntypedFormControl;
  }
  get DueDateTo(): UntypedFormControl {
    return this.customFilterForm.get('dueDateTo') as UntypedFormControl;
  }
  get TaskCategory(): UntypedFormControl {
    return this.customFilterForm.get('taskCategory') as UntypedFormControl;
  }

  setFilter(type: string, value: string) {
    switch (type) {
      case 'type':
        if (!this.typeFilter?.includes(value)) {
          this.typeFilter.push(value);
        } else {
          const index = this.typeFilter.indexOf(value);
          if (index > -1) {
            this.typeFilter.splice(index, 1);
          }
        }
        break;
    }
  }

  applyFilter() {
    this.applyFilterArray.clear();
    if (this.DueDateFrom.value && this.DueDateTo.value) {
      let startDate = new Date(
        new Date(this.DueDateFrom.value).setHours(0, 0, 0)
      );
      let endDate = new Date(
        new Date(this.DueDateTo.value).setHours(23, 59, 59)
      );
      this.tasksParams.set('due_date_from', {
        paramName: 'due_date_from',
        paramValue: this.timeService.ConvertLocalDateTimeToUTC(startDate),
      });
      this.tasksParams.set('due_date_to', {
        paramName: 'due_date_to',
        paramValue: this.timeService.ConvertLocalDateTimeToUTC(endDate),
      });
    }
    if (this.TaskCategory.value && this.TaskCategory.value.length > 0) {
      this.TaskCategory.value.forEach((elm: any) => {
        this.applyFilterArray.set(elm.id, {
          paramName: 'category_id',
          paramValue: elm.id,
        });
      });
    }
    if (this.typeFilter.length > 0) {
      this.typeFilter.forEach((elm: any) => {
        this.applyFilterArray.set(elm, { paramName: 'type', paramValue: elm });
      });
    }
    this.tasksParams.set('PageNumber', {
      paramName: 'PageNumber',
      paramValue: 1,
    });
    this.tasksParams.set('PageSize', {
      paramName: 'PageSize',
      paramValue: this.pageSize,
    });
    this.resetGridPagination = true;
    this.getAllTask();
  }

  resetFilter() {
    this.applyFilterArray.clear();
    this.customFilterForm.reset();
    this.typeFilter = [];
    this.tasksParams.delete('due_date_from');
    this.tasksParams.delete('due_date_to');
    this.tasksParams.set('status', {
      paramName: 'status',
      paramValue: 'Scheduled',
    });
    this.step = 'today';
    this.getAllTask();
  }
  get getApplyFilterArray(): any {
    return [...this.applyFilterArray.values()];
  }

  changeTaskParam(event: any) {
    this.getTaskByParams(this.selectedTaskType);
  }

  getTaskByParams(type: any) {
    this.step = type.key;
    type = type.key;
    this.tasksParams.set('PageNumber', {
      paramName: 'PageNumber',
      paramValue: 1,
    });
    this.tasksParams.set('first', { paramName: 'first', paramValue: 0 });
    this.resetGridPagination = true;

    if (this.applyFilterArray.size > 0) {
      this.applyFilterArray.clear();
    }

    switch (type) {
      case 'completed':
        if (this.tasksParams.has('due_date_from')) {
          this.tasksParams.delete('due_date_from');
        }
        if (this.tasksParams.has('due_date_to')) {
          this.tasksParams.delete('due_date_to');
        }
        this.tasksParams.set('status', {
          paramName: 'status',
          paramValue: 'Completed',
        });
        this.getAllTask();
        break;
      case 'scheduled':
        if (this.tasksParams.has('due_date_from')) {
          this.tasksParams.delete('due_date_from');
        }
        if (this.tasksParams.has('due_date_to')) {
          this.tasksParams.delete('due_date_to');
        }
        this.tasksParams.set('status', {
          paramName: 'status',
          paramValue: 'Scheduled',
        });
        this.getAllTask();
        break;
      case 'today':
        this.tasksParams.set('status', {
          paramName: 'status',
          paramValue: 'Scheduled',
        });
        let startDate = new Date(new Date().setHours(0, 0, 0));
        let endDate = new Date(new Date().setHours(23, 59, 59));
        this.tasksParams.set('due_date_from', {
          paramName: 'due_date_from',
          paramValue: this.timeService.ConvertLocalDateTimeToUTC(startDate),
        });
        this.tasksParams.set('due_date_to', {
          paramName: 'due_date_to',
          paramValue: this.timeService.ConvertLocalDateTimeToUTC(endDate),
        });
        this.getAllTask();
        break;
      case 'tomorrow':
        const tomorrowDate = dateCollection.find(
          (d: any) => d.name.toLowerCase() == 'tomorrow'
        );
        this.tasksParams.set('status', {
          paramName: 'status',
          paramValue: 'Scheduled',
        });
        this.tasksParams.set('due_date_from', {
          paramName: 'due_date_from',
          paramValue: this.timeService.ConvertLocalDateTimeToUTC(
            new Date(tomorrowDate?.date().setHours(0, 0, 0)!)
          ),
        });
        this.tasksParams.set('due_date_to', {
          paramName: 'due_date_to',
          paramValue: this.timeService.ConvertLocalDateTimeToUTC(
            new Date(tomorrowDate?.date().setHours(23, 59, 59)!)
          ),
        });
        this.getAllTask();
        break;
      case 'overdue':
        const yesterDay = dateCollection.find(
          (d: any) => d.name.toLowerCase() == 'yesterday'
        );

        this.tasksParams.set('status', {
          paramName: 'status',
          paramValue: 'Scheduled',
        });
        this.tasksParams.set('due_date_from', {
          paramName: 'due_date_from',
          paramValue: this.formatFromDate(new Date('01/01/0001 00:00:00')),
        });
        this.tasksParams.set('due_date_to', {
          paramName: 'due_date_to',
          paramValue: this.timeService.ConvertLocalDateTimeToUTC(
            new Date(yesterDay?.date().setHours(23, 59, 59)!)
          ),
        });
        this.getAllTask();
        break;
      case 'in 1 week':
        this.tasksParams.set('status', {
          paramName: 'status',
          paramValue: 'Scheduled',
        });

        this.tasksParams.set('due_date_from', {
          paramName: 'due_date_from',
          paramValue: this.timeService.ConvertLocalDateTimeToUTC(
            new Date(weekData('start')!.setHours(23, 59, 59)!)
          ),
        });
        this.tasksParams.set('due_date_to', {
          paramName: 'due_date_to',
          paramValue: this.timeService.ConvertLocalDateTimeToUTC(
            new Date(weekData('end')!.setHours(23, 59, 59)!)
          ),
        });

        this.getAllTask();
        break;
      case 'In 2 Weeks':
        this.tasksParams.set('status', {
          paramName: 'status',
          paramValue: 'Scheduled',
        });
        this.tasksParams.set('due_date_from', {
          paramName: 'due_date_from',
          paramValue: this.timeService.ConvertLocalDateTimeToUTC(
            new Date(weekData('nextweekstart')!.setHours(23, 59, 59)!)
          ),
        });
        this.tasksParams.set('due_date_to', {
          paramName: 'due_date_to',
          paramValue: this.timeService.ConvertLocalDateTimeToUTC(
            new Date(weekData('nextweekend')!.setHours(23, 59, 59)!)
          ),
        });

        this.getAllTask();
        break;
    }
  }
  formatFromDate(d: any) {
    const month = d.getMonth() + 1;
    const parseDate = `${d.getFullYear()}-${
      month > 9 ? month : '0' + month
    }-${d.getDate()}T00:00:00`;
    return parseDate.toString();
  }
  formatToDate(d: any) {
    const month = d.getMonth() + 1;
    const parseDate = `${d.getFullYear()}-${
      month > 9 ? month : '0' + month
    }-${d.getDate()}T23:59:59`;
    return parseDate.toString();
  }

  handleEvent(e: any) {
    if (e.selection) {
      this.selectedClient.set(e.data.data.index, e.data.data);
      this.showBulkActionBar = true;
    } else {
      this.selectedClient.delete(e.data.data.index);
      if (this.selectedClient.size > 0) {
        this.showBulkActionBar = true;
      } else {
        this.showBulkActionBar = false;
      }
    }
  }

  refreshData(e: any) {
    if (e && e.action && e.action == 'showProfile') {
      this.showClientSidebar = true;
      this.activeClientId = e?.columnData?.client_info?.id || e?.clientId;
    } else {
      this.getAllTask();
    }
  }

  showTaskCreateMultiple() {
    this.selectedClientIds = [];
    this.selectedClient.forEach((val: any, key: any, map: any) => {
      if (val && val.client_info)
        if (Array.isArray(val.client_info))
          this.selectedClientIds = val.client_info.map((obj: any) => {
            return obj.id;
          });
        else this.selectedClientIds.push(val.client_info.id);
    });
    this.showTaskMultiple = true;
  }

  get getSelectedRepresetativeIds(): Array<any> {
    let values: any = [];
    this.selectedStaffIds.forEach((elm: any) => {
      values.push({ paramName: 'assigned_to_staff_id', paramValue: elm });
    });

    return values;
  }
  selectedStaffsData(staffs: any) {
    this.selectedStaffIds = [];
    staffs.forEach((s: any) => {
      this.selectedStaffIds.push(s.id);
    });
    localStorage.setItem(
      'TASK_STAFF_LIST',
      JSON.stringify(this.selectedStaffIds)
    );
    this.getAllTask();
  }

  handleSelectAll(selection: any) {
    if (selection.checked) {
      this.showBulkActionBar = true;
      this.tableRecord.forEach((value: any, index: any) => {
        this.selectedClient.set(index, value);
      });
      this.allSelected = true;
    } else {
      this.showBulkActionBar = false;
      this.selectedClient.clear();
      this.allSelected = false;
    }
  }

  closeSidebar(event: boolean) {
    this.showClientSidebar = event;
  }

  ValidSessionOwners() {
    let claim: Claim[] = {} as Claim[];
    let staffs: STAFFINTERFACE[] = [];
    let validStaff: number[] = [];
    this.claim$.pipe(combineLatestWith(this.store.select(STAFF_STATE)))
      .subscribe(([objClaim, objStaff]) => {
        claim = objClaim;
        staffs = objStaff.staffList;
        if (staffs.length > 0) {
          staffs.forEach((stf) => {
            if ((stf.status === StaffStatus.Active || stf.status.toString() === StaffStatus[StaffStatus.Active])) {
              validStaff.push(stf.id);
            }
          });
          this._sessionOwner.next(validStaff);
          
        }
      });
  }

  deleteAllTasks() {
    this.disableDeleteBtn = true;
    var deleteTaskRequest = {} as DeleteTaskRequest;
    deleteTaskRequest.tasks =
      this.selectedClient.size > 0
        ? Array.from(this.selectedClient.values()).map((val: any) => val.id)
        : [];
    deleteTaskRequest.delete_associated_logs = true;
    this.taskService.DeleteTasks(this.tenantId, deleteTaskRequest).subscribe({
      next: async () => {
        this.translate
          .get('TASK_LIST.TASK_DELETE_MSG')
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
        this.showDeleteTaskPopup = false;
        this.disableDeleteBtn = false;
        this.selectedClient.clear();
        this.getAllTask();
      },
      error: (error) => {
        this.disableDeleteBtn = false;
        this.toastMessageService.showError(error);
      },
    });
  }

  reassignAllTasks() {
    if(this.changeSessionOwnerForm.valid){
      this.disableReassigneBtn = true;
      var reassignTaskRequest = {} as ReAssignTaskRequest;
      reassignTaskRequest.tasks = this.selectedClient.size > 0
          ? Array.from(this.selectedClient.values()).map((val: any) => val.id)
          : [];
      reassignTaskRequest.assigned_to_staff_id = this.SessionOwnerFormControl.value ? this.SessionOwnerFormControl.value.id : 0;
  
      this.taskService.ReassignTasks(this.tenantId, reassignTaskRequest).subscribe({
        next: async () => {
          this.translate
            .get('TASK_LIST.TASK_REASSIGN_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.reassignTasksPopup = false;
          this.disableReassigneBtn = false;
          this.selectedClient.clear();
          this.componentInit();
        },
        error: (error) => {
          this.disableReassigneBtn = false;
          this.toastMessageService.showError(error);
        },
      });
    }
    else{
      this.changeSessionOwnerForm.markAllAsTouched();
      const firstElementWithError: Element | null =
      document.querySelector('.ng-invalid');
      if (firstElementWithError)
        firstElementWithError.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    
  }

  get SessionOwnerFormControl(): UntypedFormControl {
    return this.changeSessionOwnerForm.get('session_owner') as UntypedFormControl;
  }
}

// const routes: Routes = [
//   {
//     path: '',
//     component: TaskListComponent,
//     canActivate: [AuthguardService],
//     resolve: { data: TenantResolverService },
//     data: {
//       breadcrumb: 'Task List',
//       title:"Tasks"
//     },
//   },
// ]